import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";
import { ICenterPrinter } from "../../../../../.MODULS/BOOKLET_ADMIN_MODUL/Master/Center_Printer/ICenterPrinter";

export const CentreMasterMappingReadSlice = createSlice({
  name: "CentreMasterMappingReadSlice",
  initialState: {} as IReduxState<ICenterPrinter>,
  reducers: {
    centreMasterMappingRead: (state) => {
      state.isLoading = true;
    },
    successCentreMasterMappingRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCentreMasterMappingRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCentreMasterMappingRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  centreMasterMappingRead,
  successCentreMasterMappingRead,
  failureCentreMasterMappingRead,
  clearCentreMasterMappingRead,
} = CentreMasterMappingReadSlice.actions;

export default CentreMasterMappingReadSlice.reducer;
